
export class AppSettings {
  environment: string;
  forceTenant?: string | null;
  apiUrl: string;
  apiSubscriberKey: string;
  appInsightsInstrumentationKey: string;
  googleAnalyticsKey: string;
}
